import { render, staticRenderFns } from "./ForumStockWorkspaceDialog.vue?vue&type=template&id=68809de6&scoped=true&"
import script from "./ForumStockWorkspaceDialog.vue?vue&type=script&lang=js&"
export * from "./ForumStockWorkspaceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ForumStockWorkspaceDialog.vue?vue&type=style&index=0&id=68809de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68809de6",
  null
  
)

export default component.exports